import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditCategories from './AddEditCategories';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
            { id: 'image', label: 'Thumbnail' },
            { id: 'created', label: 'Created' },
            { id: 'description', label: 'Description' }
        ])

        setHeadMobileCells([
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
            { id: 'created', label: 'Created' },
            { id: 'updated', label: 'Updated' },
            { id: 'description', label: 'Description' }
        ])

        setEditCells([
            { id: 'image', label: 'Image' },
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
            { id: 'description', label: 'Description' }
        ])

        setAddCells([
            { id: 'image', label: 'Image' },
            { id: 'name', label: 'Name' },
            { id: 'type', label: 'Type' },
            { id: 'description', label: 'Description' }
        ])

        setAddCellsName({ 
            name: '', 
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            description: '',
            image: [],
            type: ''
         })
    
        setSearchValue("name")
        
    }, []);

    return (
    <Grid>
        <Table 
             {...props}
            control={true}
            disabledMove={true}
            customizeDialog={AddEditCategories}
            orderBy="created" 
            data="categories" 
            addItemButton={true}
            addItemText="Add category"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="categories_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  